// Module
var code = "<div class=\"loading-element loading-bar gradient\" ng-style=\"{'height': $ctrl.height || '8px'}\"></div> ";
// Exports
module.exports = code;